import { Link, useNavigate } from "react-router-dom";
import { Compass, ArrowLeft, Home } from "lucide-react";
import Layout from "../components/Layout";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Layout title="Page not found" subtitle="404">
      <div
        className="pm-card max-w-2xl mx-auto px-8 py-14 text-center"
        data-testid="not-found-page"
      >
        <div className="w-16 h-16 rounded-2xl bg-emerald-50 text-emerald-700 mx-auto flex items-center justify-center mb-6">
          <Compass size={28} />
        </div>
        <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-slate-500 mb-2">
          Lost in the locker room
        </div>
        <h2 className="font-display text-3xl font-black tracking-tight text-slate-900 mb-3">
          We couldn't find that page.
        </h2>
        <p className="text-sm text-slate-600 max-w-md mx-auto leading-relaxed">
          The link may be outdated, or the page may have moved as Playmaker evolved.
          Use the buttons below to get back on track.
        </p>
        <div className="mt-7 flex items-center justify-center gap-3 flex-wrap">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="pm-btn-secondary h-10 px-4 rounded-xl text-sm font-bold flex items-center gap-1.5"
            data-testid="not-found-back"
          >
            <ArrowLeft size={13} /> Back
          </button>
          <Link
            to="/dashboard"
            className="pm-btn-primary h-10 px-5 rounded-xl text-sm font-bold flex items-center gap-1.5"
            data-testid="not-found-home"
          >
            <Home size={13} /> Go to dashboard
          </Link>
        </div>
      </div>
    </Layout>
  );
}
